import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import dayjs from 'dayjs';
import { useLocale } from '../../../localization/LocaleProvider';
import { useApi } from '../../../context/ApiProvider';
import { parseInvoiceData } from '../../RolfAdmin/invoiceCalculations';

const InvoiceModal = (props) => {
    const [session, setSession] = useState(null); //Session för att kolla om anv. är admin och isåfall visa radera-knapp
    const { modalData, closeModal, onRefresh } = props;
    const { translate } = useLocale();
    const Api = useApi();

    const invoiceData = modalData.invoice ? parseInvoiceData(modalData.invoice) : null;
    const invoiceMetadata = invoiceData?.invoiceMetadata;

    useEffect(() => {
        Api.getSession().then(session => {
            if (!session?.ID) {
                setSession(false);
                return;
            }

            Api.get(`/administrators/${session.ID}`).then(user => {
                setSession(user);
            })
        })

    }, [modalData]);


    function handleDeleteInvoice(invoiceId) {
        if (invoiceData.invoicePaid || invoiceData.commissionPaid || invoiceData.commissionInvoiced) {
            alert("You cannot delete an invoice that has been paid or where the commission has been invoiced or paid.");
            return;
        }

        if (window.confirm("Are you sure you want to delete this invoice?")) {

            Api.delete(`/rolf/invoices/${invoiceId}`)
                .then(() => {
                    onRefresh && onRefresh(); // Refresh invoices after deletion
                    closeModal(); // Close the modal after deletion
                    alert("Invoice deleted successfully.");
                }).catch(() => {
                    alert("Error deleting invoice. Please try again later.");
                });
        }
    }



    return (invoiceData &&
        <Modal isOpen={modalData.visible} onClose={closeModal} modalTitle={translate("Invoice details")}>
            <h3>{translate("Invoice to")} {invoiceData.customerName}, {dayjs.unix(modalData.invoice.invoiceDate).format("YYYY-MM-DD")} </h3>
            <p><strong>{translate("Total value:")}</strong> {invoiceData.value}:-<br />
                <strong>{translate("Invoice paid:")}</strong> {invoiceData.invoicePaid ? translate("Yes") : translate("No")}</p>
            <table>
                <thead>
                    <tr>
                        <th>{translate("Partner name")}</th>
                        <th>{translate("Total Commission")}</th>
                        <th>{translate("Commission invoiced")}</th>
                        <th>{translate("Commission paid")}</th>
                    </tr>
                </thead>
                <tbody>
                    {invoiceData.partnerId ?
                        <tr>
                            <td>{invoiceData.partnerName}</td>
                            <td>{invoiceData.commission}:-</td>
                            <td>{invoiceData.commissionInvoiced ? translate("Yes") : translate("No")}</td>
                            <td>{invoiceData.commissionPaid ? translate("Yes") : translate("No")}</td>
                        </tr>
                        :
                        <tr><td colSpan={4}>{translate("No partner")}</td></tr>
                    }
                </tbody>
            </table>

            {!invoiceMetadata ? null :
                <>
                    <h4>{translate("Details")}</h4>

                    <table>
                        <thead>
                            <tr>
                                <th>{translate("Module")}</th>
                                <th>{translate("Price")}</th>
                                <th>{translate("Nr of modules")}</th>
                                <th>{translate("Sum")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceMetadata.clientModules && invoiceMetadata.clientModules.map((module, index) => (
                                <tr>
                                    <td key={index}>
                                        <span style={{ textTransform: "capitalize" }}>{module.name}</span>
                                    </td>
                                    <td>
                                        {invoiceMetadata.modulePrices[module.name] ? `${invoiceMetadata.modulePrices[module.name]}:-` : ""}
                                    </td>
                                    <td>
                                        {module.count}
                                    </td>
                                    <td>
                                        {module.count * (invoiceMetadata.modulePrices[module.name] ? invoiceMetadata.modulePrices[module.name] : 0) + ":-"}
                                    </td>
                                </tr>
                            ))}

                            {invoiceMetadata.implementationFee && invoiceMetadata.implementationFee > 0 ?
                                <tr>
                                    <td colSpan={3}>
                                        {translate("Implementation fee:")}
                                    </td>
                                    <td>
                                        {invoiceMetadata.implementationFee}:-
                                    </td>
                                </tr>
                                : null
                            }

                            <tr>
                                <td colSpan={3}>
                                    <b>{translate("Total:")} </b>
                                </td>
                                <td><b>{invoiceMetadata.modulePrices && Object.entries(invoiceMetadata.modulePrices).reduce((acc, [moduleName, modulePrice]) => {
                                    const moduleCount = invoiceMetadata.clientModules.find(module => module.name === moduleName)?.count || 0;
                                    return acc + (moduleCount * modulePrice);
                                }, 0) + (invoiceMetadata.implementationFee || 0)
                                }:-</b></td>
                            </tr>
                        </tbody>
                    </table>

                    {invoiceMetadata.billingInterval && invoiceMetadata.billingInterval > 1 && <span className='meta'>{translate("Note: The billing interval is set to ") + invoiceMetadata.billingInterval + translate(" months. The number of modules and the invoice value are therefore multiplied by this factor.")}</span>}

                    {invoiceMetadata.totalModules < invoiceMetadata.minimumLicenses && <span className='meta'>{translate("Note: The number of modules is less than the minimum licenses. The invoice value is therefore based on minimum licenses.")}</span>}

                    {invoiceMetadata.implementationFeeCommission && invoiceMetadata.implementationFeeCommission > 0 ? <p><strong>{translate("Commission on implementation fee:")}</strong> {invoiceMetadata.implementationFeeCommission}:-</p> : null}

                    <table>
                        <thead>
                            <tr>
                                <th>{translate("Price model")}</th>
                                <th>{translate("Total users")}</th>
                                <th>{translate("Minimum licenses")}</th>
                                <th>{translate("Total modules")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{invoiceMetadata.priceModel === "new" ? translate("New price model") : translate("Old price model")}</td>
                                <td>{invoiceMetadata.nrMembers ?? ""}</td>
                                <td>{invoiceMetadata.minimumLicenses ?? ""}</td>
                                <td>{invoiceMetadata.totalModules ?? ""}</td>
                            </tr>
                        </tbody>
                    </table>

                </>
            }

            <div className="flexRow">
                <button onClick={closeModal}>{translate("Close")}</button>
                {session?.rolf == 1 ? <button className='button delete' onClick={() => handleDeleteInvoice(modalData.invoice.ID)}>{translate("Delete")}</button> : null}
            </div>
        </Modal>)
}

export default InvoiceModal;